import { component$ } from "@builder.io/qwik";
import { Select } from "~/components/ui/select";
import { LuCheck } from "@qwikest/icons/lucide";

export const Dropdown = component$(
  ({
    field,
    props,
    options,
  }: {
    field: any;
    props: any;
    options: string[];
  }) => (
    <Select.Root name={field.name} value={field.value ?? undefined}>
      <Select.HiddenNativeSelect value={field.value ?? undefined} {...props} />
      <Select.Trigger>
        <Select.DisplayValue placeholder={field.value || "Select an option"} />
      </Select.Trigger>
      <Select.Popover gutter={8} floating="bottom-start">
        {options.map((option) => (
          <Select.Item key={option} value={option}>
            <Select.ItemLabel>{option}</Select.ItemLabel>
            <Select.ItemIndicator>
              <LuCheck class="h-4 w-4" />
            </Select.ItemIndicator>
          </Select.Item>
        ))}
      </Select.Popover>
    </Select.Root>
  ),
);
